<div
  class="floating-button"
  [class.floating-button-with-indicator]="isActiveFilter"
  (click)="openModal()"
></div>
